import { render, staticRenderFns } from "./waybill.vue?vue&type=template&id=4c5b197e&scoped=true"
import script from "./waybill.vue?vue&type=script&lang=js"
export * from "./waybill.vue?vue&type=script&lang=js"
import style0 from "./waybill.vue?vue&type=style&index=0&id=4c5b197e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5b197e",
  null
  
)

export default component.exports